import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Tada from "react-reveal/Tada";

const skills = [
  { name: "C", color: "#fe3e57", percentage: 70, progress: 70 },
  { name: "C++", color: "#54faae", percentage: 70, progress: 70 },
  { name: "JAVA", color: "#54faae", percentage: 80, progress: 80 },
  { name: "JavaScript", color: "#f1f965", percentage: 85, progress: 85 },
  { name: "TypeScript", color: "blue", percentage: 80, progress: 85 },
  { name: "React js", color: "#41f2ff", percentage: 85, progress: 85 },
  { name: "NodeJS", color: "#ff8c2f", percentage: 70, progress: 70 },
  { name: "Flutter", color: "#018dffff", percentage: 70, progress: 70 },
  { name: "Dart", color: "#018dffff", percentage: 70, progress: 70 },
  { name: "MySQL", color: "#ff0173", percentage: 60, progress: 60 },
  { name: "Python", color: "#39c4ff", percentage: 40, progress: 40 },
  { name: "GraphQL", color: "#f375d9ff", percentage: 40, progress: 40 },
  { name: "PHP", color: "#fe3e57", percentage: 40, progress: 40 },
];

export default function TechnicalSkill() {
  return (
    <div>
      <div className="mt-5 d-flex flex-row justify-content-center">
        <Link className="btn btn-primary me-3" to="/technicalSkill">
          Technical Skill
        </Link>
        <Link className="btn btn-primary me-3" to="/personalskill">
          Personal Skill
        </Link>
        <Link className="btn btn-primary " to="/toolkit">
          Toolkit
        </Link>
      </div>
      <Tada>
        <h1 className="mt-4">Technical Skills</h1>
      </Tada>
      <div className="mt-5">
        <Container>
          <Row className="g-5">
            {skills.map((skill, index) => (
              <Col md={4} key={index}>
                <h1
                  style={{
                    fontSize: "100px",
                    color: skill.color,
                    fontWeight: 700,
                  }}
                >
                  {skill.percentage}%
                </h1>
                <div style={{ paddingLeft: "50px", paddingRight: "50px" }}>
                  <div className="progress">
                    <div
                      role="progressbar"
                      aria-valuenow={skill.progress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{
                        width: `${skill.progress}%`,
                        backgroundColor: skill.color,
                      }}
                    ></div>
                  </div>
                  <h2
                    style={{
                      color: skill.color,
                      fontSize: "25px",
                      marginTop: "13px",
                      fontWeight: 700,
                    }}
                  >
                    {skill.name}
                  </h2>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </div>
  );
}
